import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { connect } from 'react-redux';
import PopUp from '../../../../Shared/Popup/PopUp';
import Config from '../../../../../Config';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {prepareUrl} from '../../../../../utilities/StringHelpers/StringHelpers';
import { reportDWH } from '../../saleJetBlockSlice';

const PackageForUpgradePopUp = (props) => {

  function openTermsInNewTab(e, link) {
    props.reportDWH({ actionType: 'PopUp Upgrade Package', status: 'Ongoing', messageText: 'Upgrade More Info Clicked' });
    e.preventDefault();
    if (link) {
      prepareUrl(`${link}`, props.context);
    }
  }

  return (
    <PopUp
      showPopUp={props.showPopup}
      onClose={() => {
        props.togglePopUp(false);
      }}
      className='package-for-upgrade-sale-jet-popup'>
      <Image src={Config.epiBaseUrl + props.details.image} alt='' />
      <div className='title' dangerouslySetInnerHTML={{__html: props.details.title}}></div>
      <div className='text' dangerouslySetInnerHTML={{__html: props.details.text}}></div>
      <div className='buttons-wrapper'>
        <div className='btn-right'>
          <BtnWhiteBlackBorderBigSize
            text={props.details.buttonNoText}
            onclick={() => {
              props.onClickBtn(false);
            }}
          />
        </div>
        <div className='btn-left'>
          <BtnSubmit
            isBusiness={false}
            text={props.details.buttonYesText}
            onclick={() => {
              props.onClickBtn(true);
            }}
            formid={'package-for-upgrade-popUp'}
            isDisplayArrows={false}
          />
        </div>
      </div>
      <a href='#' className='program-details-link' onClick={(e) => openTermsInNewTab(e, props.details?.package?.programDetailsLink?.value)}>
        עיקרי התוכנית
      </a>
      <p className='legal-note'>גלישה ברשת דור 5 תתאפשר בהתאם לאזורי כיסוי, מכשיר תומך וגרסה תומכת</p>
    </PopUp>
  );
};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = {
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageForUpgradePopUp);
